<template lang="pug">
v-slide-y-reverse-transition(hide-on-leave)
  .bar(xs12 :style='style' v-if='show')
    v-divider.mt-3
    .body
      v-btn(flat @click='$emit(`cancel`)' :disabled='disabled') {{ $t('discard') }}
      v-btn(
        depressed
        color='primary'
        @click='$emit(`submit`)'
        :disabled='disabled || !valid'
        :loading='loading'
      )
        v-icon(left small) save
        | {{ $t('save') }}
</template>

<script>
export default {
  name: 'StickyBottomSaveContent',
  props: {
    show: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style () {
      return {
        backgroundColor: this.isDarkTheme ? '#303030' : '#fafafa',
      }
    },
  },
}
</script>

<style scoped lang="sass">
.bar
  position: sticky
  bottom: 0
  text-align: right
  margin-left: -1rem
  margin-right: -1rem
  z-index: 1

.body
  padding: .5rem
  padding-bottom: max(.5rem, env(safe-area-inset-bottom))
</style>

<i18n src="@/lang/components/stickyBottomSaveContent.json"></i18n>
